module.exports = __webpack_public_path__ + "img/newt4.4040deea.png";